const emailStatus = {
  UNVERIFIED: 'UNVERIFIED',
  SENT_VERIFICATION_LINK: 'SENT_VERIFICATION_LINK',
  VERIFIED: 'VERIFIED',
};

export default emailStatus;
